import { InjectionToken } from '@angular/core';

/**
 * token to inject to retrieve data from dialog
 */
export const KAL_SNACKBAR_CONFIG = new InjectionToken<{}>('KalSnackbarConfig');
